export const textGroup = {
  "bold-32": "text-[2rem] font-bold leading-10",
  "bold-24": "text-3xl font-bold leading-7",
  "bold-22": "text-2xl font-bold leading-6",
  "bold-20": "text-xl font-bold leading-6",
  "bold-18": "text-lg font-bold leading-6",
  "bold-16": "text-base font-bold leading-5",
  "bold-14": "text-sm font-bold leading-4",
  "bold-12": "text-xs font-bold leading-[14px]",
  "bold-10": "text-[10px] font-bold leading-3",
  "bold-8": "text-[8px] font-bold leading-[10px]",
  "semi-32": "text-[2rem] font-semibold leading-10",
  "semi-24": "text-3xl font-semibold leading-7",
  "semi-22": "text-2xl font-semibold leading-6",
  "semi-20": "text-xl font-semibold leading-6",
  "semi-16": "text-base font-semibold leading-5",
  "semi-14": "text-sm font-semibold leading-4",
  "semi-12": "text-xs font-semibold leading-[14px]",
  "semi-10": "text-[10px] font-semibold leading-[14px]",
  "semi-8": "text-[8px] font-semibold leading-[10px]",
  "medium-32": "text-[2rem] font-medium leading-10",
  "medium-24": "text-3xl font-medium leading-7",
  "medium-22": "text-2xl font-medium leading-6",
  "medium-20": "text-xl font-medium leading-6",
  "medium-16": "text-base font-medium leading-5",
  "medium-14": "text-sm font-medium leading-4",
  "medium-12": "text-xs font-medium leading-[14px]",
  "medium-10": "text-[10px] font-medium leading-4",
  "medium-8": "text-[8px] font-medium leading-[10px]",
  "normal-32": "text-[2rem] font-normal leading-10",
  "normal-24": "text-3xl font-normal leading-7",
  "normal-22": "text-2xl font-normal leading-6",
  "normal-20": "text-xl font-normal leading-6",
  "normal-16": "text-base font-normal leading-5",
  "normal-14": "text-sm font-normal leading-4",
  "normal-12": "text-xs font-normal leading-[14px]",
  "normal-10": "text-[10px] font-normal leading-3",
  "normal-8": "text-[8px] font-normal leading-[10px]",
};

const Text = ({ children, variant, className, ...rest }) => {
  return (
    <p
      className={(textGroup[variant] ?? "medium-16").concat(
        ` ${className ?? ""}`
      )}
      {...rest}
    >
      {children}
    </p>
  );
};

export default Text;
